import { render, staticRenderFns } from "./allocationTask.vue?vue&type=template&id=cb4d08d2&"
import script from "./allocationTask.vue?vue&type=script&lang=js&"
export * from "./allocationTask.vue?vue&type=script&lang=js&"
import style0 from "./allocationTask.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports